module.exports = __webpack_public_path__ + "static/chicago-e1d319dbd6fdf99bd776f50f3e7a4f1b.png";